import _get from 'lodash/get'

export default class {
  constructor (config) {
    this.manifestStates = config.manifestStates

    // These are validator configs which are meant to be reused in the states below
    let validateMaxPrintColors = {
      name: 'validateMaxPrintColors',
      statesAffected: [
        'bandbuilder.silicone.text',
        'bandbuilder.silicone.graphics',
        'bandbuilder.silicone.style'
      ]
    }
    let validatePrintColorIsSameAsBandColor = {
      name: 'validatePrintColorIsSameAsBandColor',
      statesAffected: [
        'bandbuilder.silicone.text',
        'bandbuilder.silicone.graphics',
        'bandbuilder.silicone.style'
      ]
    }
    let isExtraColorFee = {
      name: 'isExtraColorFee',
      statesAffected: [
        'bandbuilder.silicone.text',
        'bandbuilder.silicone.graphics'
      ],
      isWarning: true
    }
    let isExtraSizeFee = {
      name: 'isExtraSizeFee',
      statesAffected: [
        'bandbuilder.silicone.style'
      ],
      isWarning: true
    }
    let hasBothColorfillAndNoColorfill = {
      name: 'hasBothColorfillAndNoColorfill',
      statesAffected: [
        'bandbuilder.silicone.text',
        'bandbuilder.silicone.graphics'
      ],
      isWarning: true
    }

    // let printColorsLocked = {
    //   name: 'validatePrintColorsLocked',
    //   statesAffected: [
    //     'bandbuilder.silicone.text',
    //     'bandbuilder.silicone.graphics'
    //   ],
    //   isWarning: true,
    //   onlyShowOnTheseStates: [
    //     'bandbuilder.silicone.text',
    //     'bandbuilder.silicone.graphics'
    //   ]
    // }

    let isCustomColor = {
      name: 'isCustomColor',
      statesAffected: [
        'bandbuilder.silicone.imprint',
        'bandbuilder.silicone.text',
        'bandbuilder.silicone.graphics',
        'bandbuilder.silicone.style'
      ],
      isWarning: true
    }

    let validateArea1TextRequired = {
      name: 'validateArea1TextRequired',
      statesAffected: [
        'bandbuilder.silicone.text'
      ]
    }

    let validateAreaTextRequired = {
      name: 'validateAreaTextRequired',
      statesAffected: [
        'bandbuilder.silicone.text'
      ]
    }

    let validateAllFontCharacters = {
      name: 'validateAllFontCharacters',
      statesAffected: [
        'bandbuilder.silicone.text'
      ]
    }

    // The validators need to have a matching method with the same name in class Customband
    this.siliconeStates = [
      {
        name: 'bandbuilder.silicone.imprint',
        validators: [
          isCustomColor
        ]
      },
      {
        name: 'bandbuilder.silicone.text',
        validators: [
          isCustomColor,
          'isValidPhrases',
          validateMaxPrintColors,
          validatePrintColorIsSameAsBandColor,
          isExtraColorFee,
          hasBothColorfillAndNoColorfill,
          validateAreaTextRequired,
          validateArea1TextRequired,
          validateAllFontCharacters
        ]
      },
      {
        name: 'bandbuilder.silicone.graphics',
        validators: [
          isCustomColor,
          'graphicsAreValid',
          validateMaxPrintColors,
          isExtraColorFee,
          hasBothColorfillAndNoColorfill
        ]
      },
      {
        name: 'bandbuilder.silicone.style',
        validators: [
          isCustomColor,
          'validateNotes',
          'validateOrderRows',
          'validateMOQ',
          validatePrintColorIsSameAsBandColor,
          isExtraSizeFee
        ]
      }
    ]

    this.tyvekStates = [
      {
        name: 'bandbuilder.tyvek.colors',
        validators: []
      },
      {
        name: 'bandbuilder.tyvek.content',
        validators: [
          'validateStartingNumber'
        ]
      },
      {
        name: 'bandbuilder.tyvek.quantity',
        validators: [
          'validateTyvekQuantity'
        ]
      }
    ]

    let states = (config.type === 'tyvek') ? this.tyvekStates : this.siliconeStates

    // Default hidden property to false
    for (let state of states) {
      state.hidden = false
    }

    // Only include the states from the manifest
    states = states.filter(state => {
      return this.manifestStates.find(s => state.name === s.state)
    })

    // Grab the text names and icons from the manifest
    for (let state of states) {
      let manifestState = this.manifestStates.find(s => state.name === s.state)
      if (typeof manifestState !== 'undefined') {
        state.textName = manifestState.name
        state.icon = _get(manifestState, 'icon')
      }
    }

    this.states = states
    this.completed = {}
    this.completed[this.states[0].name] = true

    this.visited = {}
    this.isDirty = {}
  }

  reset () {
    this.completed = {}
    this.visited = {}
  }

  allCompleted () {
    for (let state of this.states) {
      let isComplete = _get(this.completed, state.name)
      if (!isComplete) {
        return false
      }
    }

    return true
  }

  firstRouteName () {
    for (let state of this.states) {
      if (!state.hidden) {
        return state.name
      }
    }
  }

  lastRouteName () {
    let lastRouteName = null
    for (let state of this.states) {
      if (!state.hidden) {
        lastRouteName = state.name
      }
    }
    return lastRouteName
  }

  nextStateName (currentName) {
    let nextStateName = null
    let currentIndex = this.states.findIndex(state => state.name === currentName)
    let currentState = this.states[currentIndex]
    if (currentIndex !== -1) {
      let routeIndex = currentIndex + 1
      while (nextStateName === null) {
        let route = _get(this.states, routeIndex, null)
        if (route) {
          if (!route.hidden) {
            nextStateName = route.name
          }
        } else {
          nextStateName = currentState.name
        }

        routeIndex++
      }
    } else {
      nextStateName = currentState.name
    }

    return nextStateName
  }

  previousStateName (currentName) {
    let previousStateName = null
    let currentIndex = this.states.findIndex(state => state.name === currentName)
    let currentState = this.states[currentIndex]
    if (currentIndex !== -1) {
      // Find previous route that's not hidden
      let routeIndex = currentIndex - 1
      while (previousStateName === null) {
        let route = _get(this.states, routeIndex, null)
        if (route) {
          if (!route.hidden) {
            previousStateName = route.name
          }
        } else {
          previousStateName = currentState.name
        }

        routeIndex--
      }
    } else {
      previousStateName = currentState.name
    }

    return previousStateName
  }

  checkVisibleStates (printStyle) {
    let changes = []
    if (printStyle.print_style.code === 'blank') {
      for (let state of this.states) {
        let currentHidden = _get(state, 'hidden', null)
        let hidden = state.name === 'bandbuilder.silicone.text' || state.name === 'bandbuilder.silicone.graphics'
        if (currentHidden !== hidden) {
          changes.push({
            state,
            hidden: hidden
          })
        }
      }
    } else {
      for (let state of this.states) {
        let currentHidden = _get(state, 'hidden', null)
        if (currentHidden !== false) {
          changes.push({
            state,
            hidden: false
          })
        }
      }
    }
    return changes
  }

  getStatesAffected (validatorName) {
    for (const state of this.states) {
      if (state.validators) {
        for (const validator of state.validators) {
          if (typeof validator === 'object') {
            if (validator.name === validatorName) {
              return validator.statesAffected
            }
          }
        }
      }
    }

    // If this validator doesn't specify the states affected, then return all the state names that this validator name is found in
    let statesAffected = []
    for (const state of this.states) {
      if (state.validators) {
        if (state.validators.include(validatorName)) {
          statesAffected.push(state.name)
        }
      }
    }

    return statesAffected
  }
}
